import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';
import { useDate } from '../../contexts/date-context';
import { Select } from '../ui/select-custom';
import { Button } from '../ui/button';

const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

const monthOptions = MONTHS.map((name, index) => ({
  value: (index + 1).toString(),
  label: name,
}));

const currentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: 10 }, (_, i) => {
  const yearValue = currentYear - 5 + i;
  return { value: yearValue.toString(), label: yearValue.toString() };
});

export function MonthYearSelector() {
  const { month, year, setMonth, setYear, setMonthYear } = useDate();

  const handlePreviousMonth = () => {
    if (month === 1) {
      setMonthYear(12, year - 1);
    } else {
      setMonth(month - 1);
    }
  };

  const handleNextMonth = () => {
    if (month === 12) {
      setMonthYear(1, year + 1);
    } else {
      setMonth(month + 1);
    }
  };

  const handleToday = () => {
    const now = new Date();
    setMonthYear(now.getMonth() + 1, now.getFullYear());
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={handlePreviousMonth}
        className="h-9 w-9 p-0"
      >
        <ChevronLeft className="size-4" />
      </Button>

      <div className="flex items-center gap-2">
        <Select
          value={month.toString()}
          onChange={(value) => setMonth(parseInt(value))}
          options={monthOptions}
        />

        <Select
          value={year.toString()}
          onChange={(value) => setYear(parseInt(value))}
          options={yearOptions}
        />
      </div>

      <Button
        variant="ghost"
        size="sm"
        onClick={handleNextMonth}
        className="h-9 w-9 p-0"
      >
        <ChevronRight className="size-4" />
      </Button>

      <Button
        variant="outline"
        size="sm"
        onClick={handleToday}
        className="h-9 px-3"
      >
        <Calendar className="size-4" />
        <span className="hidden sm:inline">Hoje</span>
      </Button>
    </div>
  );
}
